import { render, staticRenderFns } from "./FormGeneralInfo.vue?vue&type=template&id=0872f774&scoped=true&"
import script from "./FormGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./FormGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormGeneralInfo.vue?vue&type=style&index=0&id=0872f774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0872f774",
  null
  
)

export default component.exports